<template>
  <header
    v-if="isConnected"
    class="pt-3"
  >
    <div class="flex justify-content-end align-content-end">
      <div
        id="user-info"
        class="mr-3"
      >
        <div class="flex flex-column align">
          <span class="text-right">{{ $t("nav.userProfile") }} {{ firstname }} {{ lastname }}</span>
          <span class="text-sm text-right">{{ isUser ? stakeholderName : $t(`entity.user.roles.${role}`) }}</span>
          <span
            v-if="isApprover"
            class="text-sm text-right"
          >{{ $t('entity.user.roles.approver') }}</span>
          <div
            class="flex justify-content-end mt-2 cursor-pointer"
            @click.stop="disconnect"
          >
            <i class="pi pi-power-off" />
            <span class="ml-2">{{ $t("nav.logout") }}</span>
          </div>
        </div>
      </div>

      <div>
        <LocaleChooserComponent />
      </div>
    </div>
    <div class="container">
      <Menubar :model="menuItems">
        <template #start>
          <img
            v-if="applicationLogo"
            alt="logo"
            :src="applicationLogo"
          >
        </template>
      </Menubar>
    </div>
  </header>
</template>
<script>
import LocaleChooserComponent from "@/components/LocaleChooserComponent";
import {ADMIN_ROLE, AGENT_ROLE, CONTACT_ROLE} from "@/shared/constants";
import logoMixin from '../mixin/logoUrlMixins'
import Menubar from "primevue/menubar";

export default {
  name: "HeaderComponent",
  components: {LocaleChooserComponent, Menubar},
  mixins: [logoMixin],
  computed: {
    menuItems() {
      return [
        {
          to: "/appointment/new",
          label: this.$t("nav.createAppointment"),
          visible: this.isUser
        },
        {
          to: "/appointment",
          label: this.$t("nav.appointments"),
          visible: this.isAgent || this.isAdmin
        },
        {
          to: "/appointment/user",
          label: this.$t("nav.appointments"),
          visible: this.isUser,
        },
        {
          to: "/specialRequest/new/",
          label: this.$t("nav.specialrequest"),
          visible: this.isUser,
        },
        {
          to: "/immediate-tagging",
          label: this.$t("nav.immediateTagging"),
          visible: this.isAgent || this.isAdmin,
        },
        {
          to: "/specialRequest",
          label: this.$t("nav.specialrequests"),
          visible: this.isAdmin,
        },
        {
          to: "/tag-history",
          label: this.$t("nav.userTagHistory"),
          visible: this.isUser,
        },
        {
          to: "/tag",
          label: this.$t("nav.tag"),
          visible: this.isAdmin || this.isAgent,
        },
        {
          to: "/lineId",
          label: this.$t("nav.lineId"),
          visible: this.isAdmin || this.isAgent,
        },
        {
          to: "/user",
          label: this.$t("nav.user"),
          visible: this.isAdmin || this.isAgent || this.isApprover,
        },
        {
          to: "/stakeholder",
          label: this.$t("nav.stakeholder"),
          visible: this.isAdmin,
        },
        {
          to: "/site",
          label: this.$t("nav.site"),
          visible: this.isAdmin,
        },
        {
          to: "/office",
          label: this.$t("nav.office"),
          visible: this.isAdmin,
        },
        {
          to: "/roamingTeam",
          label: this.$t("nav.roamingTeam"),
          visible: this.isAdmin,
        },
        {
          to: "/venue",
          label: this.$t("nav.venue"),
          visible: this.isAdmin
        },
        {
          to: "/equipmentType",
          label: this.$t("nav.equipmentType"),
          visible: this.isAdmin
        },
        {
          to: "/settings",
          label: this.$t("nav.settings"),
          visible: this.isAdmin
        }
      ]
    },
    isConnected() {
      return !!this.$store.state.auth.user;
    },
    isAdmin() {
      return this.$store.state.auth.user.role === ADMIN_ROLE;
    },
    isAgent() {
      return this.$store.state.auth.user.role === AGENT_ROLE;
    },
    isUser() {
      return this.$store.state.auth.user.role === CONTACT_ROLE;
    },
    isApprover() {
      return this.$store.state.auth.user.approver;
    },
    firstname() {
      return this.$store.state.auth.user.firstname;
    },
    lastname() {
      return this.$store.state.auth.user.lastname;
    },
    role() {
      switch(this.$store.state.auth.user.role){
        case ADMIN_ROLE:
          return 'admin';
        case AGENT_ROLE:
          return 'agent';
        case CONTACT_ROLE:
          return 'contact';
        default:
          return null;
      }
    },
    stakeholderName(){
      return this.isUser ? this.$store.state.auth.user.stakeholder.name : null;
    }
  },
  methods: {
    disconnect() {
      this.$store.dispatch("auth/logout")
        .then(() => this.$router.push({name: "login"}));
    },
  }
}
</script>

<style lang="scss">

header {
  background: url("../assets/images/head.jpg") center center / cover no-repeat !important;
  box-shadow: inset 0 0 0 1000px rgba(18, 147, 215, .6);
  min-height: 170px;
  padding: 0 20px 20px 20px !important;

  .p-menubar {
    background: transparent;
    border: none;

    .p-menubar-button {
      color: white;
      border-radius: 4px !important;
      margin-left: auto;

      .pi {
        font-size: 2rem;
        border: none !important;
      }

      &:hover {
        background-color: transparent !important;
      }

      &[display="flex"] {
        margin-left: auto !important;

      }
    }

    .p-menubar-start {
      padding-right: 20px;
    }

    .p-menuitem {
      margin: 0 5px 5px 0;

      .p-menuitem-content {
        background: transparent !important;

        a {
          background: transparent !important;
          transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1);
          border-radius: 4px;

          .p-menuitem-text, .p-menuitem-icon {
            color: white !important;
          }

          &:hover, &.router-link-active {
            color: white !important;
            background-color: rgba(0, 0, 0, 0.6) !important;
          }
        }
      }
    }

    &.p-menubar-mobile-active {

      .p-menuitem {
        margin: 0;

        .p-menuitem-content {
          a {
            transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1);
            border-radius: 0;

            &:hover, &.router-link-active {
              .p-menuitem-text, .p-menuitem-icon {
                color: white !important;
              }
            }
          }

          .p-menuitem-text, .p-menuitem-icon {
            color: gray !important;
          }
        }
      }
    }
  }

  #user-info{
    color: white;
    font-weight: bold;
  }
}

</style>
